import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = ({ style = {} }) => {
  const [hover, setHover] = useState(false);

  return (
    <a
      href="https://wa.me/919542643011?text=Hi%20DigiHR%2C%20I%20want%20to%20book%20a%20demo"
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: 14,
        background: hover ? '#1ebe5d' : '#25D366', color: '#fff',
        borderRadius: 14, padding: '18px 24px', textDecoration: 'none',
        transition: 'background .15s', boxShadow: '0 4px 20px rgba(37,211,102,.3)',
        ...style,
      }}
    >
      <MessageCircle size={28} strokeWidth={1.75} />
      <div>
        <div style={{ fontSize: 16, fontWeight: 700 }}>Chat on WhatsApp</div>
        <div style={{ fontSize: 13, opacity: .85, marginTop: 2 }}>Fastest response · Usually replies in minutes</div>
      </div>
    </a>
  );
};

export default WhatsAppButton;
